// Components==============
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useState } from 'react';
import Avatar from '../Avatar/Avatar';
import DeleteMessageModal from './DeleteMessageModal';
import './Message.module.scss';
// =========================

type Props = {
  message: MessageEntity | FeedbackEntity;
  handleDelete?: (id: number) => void;
  type: 'comment' | 'project' | 'direct-message';
};

export default function Message({ message, handleDelete, type }: Props) {
  const userId = useRedux((state) => state.authentication?.user?.id);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const projectId = 'project_id' in message ? message.project_id : undefined;

  const theme = useRedux((state) => {
    const themeId = projectId
      ? state.project?.entities.byId?.[projectId]?.theme_id
      : undefined;

    return themeId ? state.theme?.entities.byId?.[themeId] : undefined;
  });

  const translate = useTranslate();

  const date = new Date(message?.updated_at?.replace(/-/g, '/') || '');
  const day = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  const time = `${date.getHours()}:${String(date.getMinutes()).padStart(
    2,
    '0'
  )}`;

  if (!message.author) return <></>;

  return (
    <div
      styleName={`wrapper ${
        type === 'comment'
          ? 'left'
          : message.author.id === userId
          ? 'right'
          : 'left'
      }`}
    >
      <p styleName="timestamp">
        {`${message.author.first_name} ${message.author.last_name}   ${day} - ${time}`}
        {type === 'direct-message' && (
          <>
            {theme?.name ? (
              <strong>
                {'   '}
                {theme.name}
              </strong>
            ) : (
              <strong>
                {'   '}
                {translate('project.terms.project-deleted')}
              </strong>
            )}
          </>
        )}
      </p>
      <div styleName="avatar-wrapper">
        <Avatar user={message.author} />
      </div>
      <div styleName="message-wrapper">
        {/* Delete Button */}
        {/* Condition to show/hide delete btn if author of the message is logged in 
        && message has not already been deleted */}
        {!!handleDelete &&
          message.author.id === userId &&
          message &&
          'message_data' in message &&
          message.message_data !== null && (
            <button
              type="button"
              styleName="delete"
              onClick={() => setModalIsOpen(true)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          )}
        <p
          styleName={`${
            message &&
            'message_data' in message &&
            message.message_data === null
              ? 'deleted-message'
              : 'message'
          }`}
        >
          {/* Condition to check if the auth of the msg 
          is logged in or not to render deleted msg text */}
          {message.author.id === userId &&
          message &&
          'message_data' in message &&
          message.message_data === null
            ? translate('general.deleted-message')
            : message.author.id !== userId &&
              message &&
              'message_data' in message &&
              message.message_data === null
            ? `${message.author.first_name} ${
                message.author.last_name
              } ${translate('general.user-deleted-message')}`
            : null}
          {message && 'message_data' in message && message.message_data}
          {message && 'message' in message && message?.message}
        </p>
      </div>
      <AnimatePresence>
        {modalIsOpen && (
          <DeleteMessageModal
            setModalIsOpen={setModalIsOpen}
            message={message}
            handleDelete={handleDelete!}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
